import React from "react";

import { useScoped } from "~/tools/impulse";

import { queryMetricsLabels } from "../../../../queries/metrics/labels";
import { useQuery } from "../../../../queries/react-query";
import { useDashboardContext } from "../_dashboard-context";

import { ListMultiChoiceVariable, type ListMultiChoiceVariableProps } from "./_list-multi-choice";
import { ListSingleChoiceVariable, type ListSingleChoiceVariableProps } from "./_list-single-choice";

type MultiChoiceProps = {
	allowMultiple: true;
} & Omit<ListMultiChoiceVariableProps, "options">;

type SingleChoiceProps = { allowMultiple: false } & Omit<ListSingleChoiceVariableProps, "options">;

type Props = {
	matchers: Array<string>;
} & (MultiChoiceProps | SingleChoiceProps);

export const MetricLabelNames = ({ matchers, ...props }: Props) => {
	const [dropdownVisible, setDropdownVisible] = React.useState(false);
	const { timeRange } = useDashboardContext();

	const { data, error } = useQuery({
		...queryMetricsLabels({
			timeRange: useScoped(timeRange),
			matches: matchers,
		}),
		keepPreviousData: true,
		enabled: dropdownVisible,
	});

	const options = error || data == null ? [] : data.map((value) => ({ value }));

	if (props.allowMultiple) {
		return <ListMultiChoiceVariable {...props} onDropdownVisibleChange={setDropdownVisible} options={options} />;
	}

	return <ListSingleChoiceVariable {...props} onDropdownVisibleChange={setDropdownVisible} options={options} />;
};
